<template>
  <v-layout style="height: calc(100vh - 48px)">
    <v-row>
      <v-flex v-if="loadingInitial" xs12 md12 pt-4>
        <v-layout align-center justify-center>
          <v-progress-circular
            indeterminate
            color="primary"
            :size="75"
          ></v-progress-circular>
        </v-layout>
      </v-flex>
      <v-flex v-if="invoiceDetails" xs12 md12 lg12 pr-1 pl-1 pb-1 pt-1>
        <InvoiceJobs
          :invoiceDetails="invoiceDetails"
          :loading="loadingInvoiceDetails"
          @updatePaymentType="updatePaymentType($event)"
          @setFinalCost="setFinalCost($event)"
          @setDriverPay="setDriverPay($event)"
          @setCommission="setCommission($event)"
          @resetCommission="resetCommission($event)"
          @addExtra="addExtra($event)"
          @removeExtra="removeExtra($event)"
          @errorSnackbar="showSnackbar($event, 'error')"
          @startClearInvoice="startClearInvoice"
          @commissionChanged="commissionChanged"
        />
      </v-flex>
    </v-row>
    <v-snackbar v-model="snackbarShow" :color="snackbarColour" :timeout="4000">
      <v-layout align-center justify-center>{{ snackbarMessage }}</v-layout>
    </v-snackbar>
    <v-dialog persistent v-model="showNotesDialog" max-width="500">
      <v-card>
        <v-card-title v-if="beingPaidType == 'driver'" class="white--text grey">
          <h3 class="nobold">
            Marking all invoices as paid for driver:
            <b>{{ beingPaid.driver.name }}</b>
          </h3>
        </v-card-title>
        <v-card-title
          v-if="beingPaidType == 'invoice'"
          class="white--text grey"
        >
          <h3 class="nobold">
            Marking invoice with ID:
            <b>{{ beingPaid.id }}</b> as paid
          </h3>
        </v-card-title>
        <v-card-text>
          <v-flex pl-2 pt-2>
            <h3
              class="nobold grey--text text--darken-2"
              v-if="beingPaidType == 'invoice'"
            >
              Amount Payable:
              <b>{{ formatter.format(beingPaid.totals.payable / 100) }}</b>
            </h3>
            <h3
              class="nobold grey--text text--darken-2"
              v-if="beingPaidType == 'driver'"
            >
              Amount Payable:
              <b>{{ getDriverTotal(beingPaid.invoices, "payable") }}</b>
            </h3>
          </v-flex>
          <v-flex px-2>
            <v-textarea
              label="Notes"
              v-model="beingPaidNotes"
              :error-messages="beingPaidNotesError"
              @input="beingPaidNotesError = ''"
            />
          </v-flex>
          <v-flex v-if="beingPaidType == 'driver'" px-2>
            <h5 class="nobol orange--text">
              Warning: This marks ALL invoices for the driver as paid - be sure
              you want to do this
            </h5>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="beingPaidType == 'driver'"
            text
            dark
            color="blue"
            class="text-none"
            @click="clearAccount(beingPaid.driver.id)"
            >Mark Invoices as Paid</v-btn
          >
          <v-btn
            v-if="beingPaidType == 'invoice'"
            text
            color="blue"
            class="text-none"
            @click="clearInvoice(beingPaid)"
            >Mark Invoice as Paid</v-btn
          >
            <v-btn
                v-if="beingPaidType == 'driver'"
                text
                dark
                color="blue"
                class="text-none"
                @click="clearAccount(beingPaid.driver.id, true)"
            >Charge Invoice</v-btn
            >
            
            <v-btn
            v-if="beingPaidType == 'invoice'"
            text
            color="blue"
            class="text-none"
            @click="clearInvoice(beingPaid, true)"
            >Charge Invoice</v-btn
          >
          <v-btn text color="red" class="text-none" @click="resetNotes()"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import DriverList from "@/components/invoices/DriverList.vue";
import InvoiceJobs from "@/components/invoices/InvoiceJobs.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "InvoiceDetail",
  components: {
    DriverList,
    InvoiceJobs,
  },
  data: function () {
    return {
  
      formatter: null,
      loadingInitial: true,
      loadingSummaryPage: false,
      loadingSingleDriverSummary: {
        state: false,
        driverID: -1,
      },
      loadingInvoicesForDriver: false,
      loadingInvoiceDetails: false,
      //disabled: false,
      invoicesSummary: null,
      invoicesSummaryRows: 2,
      currentOffset: -1,
      invoicesDriver: [],
      currentInvoicesDriverID: -1,
      totals: null,
      invoiceDetails: null,
      submittedSearch: {
        query: "",
        startDate: "",
        endDate: "",
        filter: ""
      },
      snackbarShow: false,
      snackbarColour: null,
      snackbarMessage: null,
      beingPaid: {},
      beingPaidNotes: "",
      beingPaidNotesError: null,
      beingPaidType: null,
      showNotesDialog: false,
      driverInfo: null,
      hasCard: false
    };
  },
  beforeMount: function () {
    if (!this.$cookies.isKey("driverSummaryRows")) {
      this.$cookies.set("driverSummaryRows", 10, Infinity);
    }
    this.invoicesSummaryRows = parseInt(this.$cookies.get("driverSummaryRows"));

    this.formatter = new Intl.NumberFormat("en-UK", {
      style: "currency",
      currency: "GBP",
      minimumFractionDigits: 2,
    });
  },
  created() {
    if (this.$route.params.id) {
      this.getInvoiceDetails(this.$route.params.id)
    }
  },
  mounted: function () {
    let self = this;
    Promise.all([this.getInvoicesSummary(0), this.getTotals()]).then(function (
      success
    ) {
      if (!success[0] || !success[1]) {
        //self.disabled = true;
      }
      self.loadingInitial = false;
    });
  },
  methods: {
    getDriverTotal: function (invoices, type) {
      let total = 0;
      invoices.forEach(function (invoice) {
        total += invoice.totals[type];
      });

      if (total == 0) {
        return "—";
      } else {
        return this.formatter.format(total / 100);
      }
    },
    startClearAccount: function (driver, invoices) {
      this.beingPaid = {
        driver: driver,
        invoices: invoices,
      };
      this.beingPaidType = "driver";
      this.showNotesDialog = true;
    },
    clearAccount: function (driverID, charge = false) {
      console.log("Clear account called");

      let payload = {
        driverID: driverID,
        notes: this.beingPaidNotes,
      };
      this.resetNotes();
      this.markAllAsPaid(payload, charge);

      this.$refs.driverList.collapse();
    },
    startClearInvoice: function (invoice, driverID, hasCard) {
      console.log(invoice);
      console.log(driverID);

      this.beingPaid = {
        ...invoice,
        driverID: driverID,
      };
      
      if (hasCard) {
          this.hasCard = true
      } else {
          this.hasCard = false
      }
      this.beingPaidType = "invoice";
      this.showNotesDialog = true;
    },
    clearInvoice: function (invoice, charge = false) {
      console.log("Clear invoice called");

      let payload = {
        invoiceID: invoice.id,
        driverID: invoice.driverID,
        notes: this.beingPaidNotes,
      };
      this.resetNotes();
      this.markAsPaid(payload);

      console.log(this.invoicesDriver);

      if (this.invoicesDriver.length == 1) {
        console.log("Collapsing as only 1 invoice");
        this.$refs.driverList.collapse();
      }
    },
    resetNotes: function () {
      this.showNotesDialog = false;
      this.beingPaidID = -1;
      this.beingPaidType = "";
      this.beingPaidNotes = "";
      this.beingPaidNotesError = "";
    },
    getInvoicesSummary: async function (offset) {
      this.currentOffset = offset;
      //this.invoicesSummary = {};
      this.loadingSummaryPage = true;
      let count = this.invoicesSummaryRows;
      let url = `${this.$store.state.apiUrl}/invoice/driver/unpaidSummary?offset=${offset}&count=${count}`;

      if (
        this.submittedSearch.query &&
        this.submittedSearch.query.trim() != ""
      ) {
        url += `&query=${this.submittedSearch.query}`;
      }
      if (
        this.submittedSearch.startDate &&
        this.submittedSearch.startDate.trim() != ""
      ) {
        url += `&start_date=${this.submittedSearch.startDate}`;
      }
      if (
        this.submittedSearch.endDate &&
        this.submittedSearch.endDate.trim() != ""
      ) {
        url += `&end_date=${this.submittedSearch.endDate}`;
      }

      if (this.submittedSearch.filter != "") {
        url += `&filter=${this.submittedSearch.filter}`;
      }

      try {
        const response = await axios.get(url);

        if (response.data.error != "no_error") {
          if (response.data.error == "no_data_available") {
            this.invoicesSummary = {};
            this.loadingSummaryPage = false;
            return true;
          } else {
            console.log(response.data.error);
            this.loadingSummaryPage = false;
            return false;
          }
        } else {
          console.log(response.data.unpaid_invoices.drivers);
          response.data.unpaid_invoices.drivers.sort(function (a, b) {
            if (a.driver.name < b.driver.name) {
              return -1;
            }
            if (a.driver.name > b.driver.name) {
              return 1;
            }
            return 0;
          });
          console.log(response.data.unpaid_invoices.drivers);
          this.invoicesSummary = response.data.unpaid_invoices;
          this.loadingSummaryPage = false;
          return true;
        }
      } catch (error) {
        console.log(error);
        this.loadingSummaryPage = false;
        return false;
      }
    },
    getInvoicesSummaryForDriver: async function (driverID) {
      console.log("getting invoices summary for driver " + driverID);
      this.invoicesDriver = [];
      this.currentInvoicesDriverID = driverID;
      this.loadingInvoicesForDriver = true;
      let url = `${this.$store.state.apiUrl}/invoice/driver/unpaidSummaryForDriver?driver_id=${driverID}`;

      try {
        const response = await axios.get(url);

        if (response.data.error != "no_error") {
          console.log(response.data.error);
          this.loadingInvoicesForDriver = false;
          return false;
        } else {
          this.invoicesDriver = response.data.unpaid_invoices;
          this.loadingInvoicesForDriver = false;
          this.driverInfo = response.data.driver;
          return true;
        }
      } catch (error) {
        console.log(error);
        this.loadingInvoicesForDriver = false;
        return false;
      }
    },
    getTotals: async function () {
      this.totals = {};
      let url = `${this.$store.state.apiUrl}/invoice/driver/totalsUnpaid`;

      try {
        const response = await axios.get(url);

        if (response.data.error != "no_error") {
          console.log(response.data.error);
          return false;
        } else {
          this.totals = response.data.totals;
          return true;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },
    getInvoiceDetails: async function (invoiceID) {
      this.invoiceDetails = {};
      this.loadingInvoiceDetails = true;
      let url = `${this.$store.state.apiUrl}/invoice/driver/get?invoice_id=${invoiceID}`;

      try {
        const response = await axios.get(url);

        if (response.data.error != "no_error") {
          console.log(response.data.error);
          return false;
        } else {
          this.invoiceDetails = {
            invoice: response.data.invoice,
          };
          return true;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },
    updateSummaryTotalsForDriver: async function (driverID) {
      console.log("updating summary totals for driver");
      this.loadingSingleDriverSummary.driverID = driverID;
      this.loadingSingleDriverSummary.state = true;
      let url = `${this.$store.state.apiUrl}/invoice/driver/unpaidSummaryForDriver?driver_id=${driverID}`;

      try {
        const response = await axios.get(url);

        if (response.data.error != "no_error") {
          console.log(response.data.error);
          this.loadingSingleDriverSummary.state = false;
          return false;
        } else {
          let driverSummary = {
            driver: response.data.driver,
            invoices: response.data.unpaid_invoices,
          };
          for (let i = 0; i < this.invoicesSummary.drivers.length; i++) {
            if (this.invoicesSummary.drivers[i].driver.id == driverID) {
              if (driverSummary.invoices.length > 0) {
                this.$set(this.invoicesSummary.drivers, i, driverSummary);
              } else {
                this.getInvoicesSummary(this.currentOffset);
                //this.invoicesSummary.drivers.splice(i, 1);
              }
              this.loadingSingleDriverSummary.state = false;
              return true;
            }
          }
          this.loadingSingleDriverSummary.state = false;
          return false;
        }
      } catch (error) {
        console.log(error);
        this.loadingSingleDriverSummary.state = false;
        return false;
      }
    },
    commissionChanged: function (driverID, invoiceID) {
      this.getTotals();

      var self = this;

      Promise.all([
        this.getInvoiceDetails(invoiceID),
      ]).then(function (success) {
        if (success[0]) {
          console.log("Great success");
          self.loadingInvoiceDetails = false;
        }
      });

      this.updateSummaryTotalsForDriver(driverID);
      this.getInvoicesSummaryForDriver(this.currentInvoicesDriverID);
    },
    markAsPaid: function (invoice, charge = false) {
      console.log("clearing an invoice");
      let self = this;
      let url = `${this.$store.state.apiUrl}/invoice/driver/markAsPaid?take_charge=${charge}`;

      self.loadingInvoiceDetails = true;

      axios({
        url: url,
        method: "POST",
        params: {
          invoice_id: invoice.invoiceID,
          notes: invoice.notes,
        },
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          self.loadingInvoiceDetails = false;

          if (res.data.error != "no_error") {
            self.showSnackbar("Failed to mark invoice as paid", "error");
          } else {
            self.showSnackbar("Invoice marked as paid", "success");

            if (invoice.driverID == self.currentInvoicesDriverID) {
              let newInvoices = self.invoicesDriver.filter((filterInvoice) => {
                return filterInvoice.id != invoice.invoiceID;
              });
              self.invoicesDriver = newInvoices;
            }
            self.updateSummaryTotalsForDriver(invoice.driverID);
            self.getTotals();

            if (
              self.invoiceDetails &&
              self.invoiceDetails.invoice.id == invoice.invoiceID
            ) {
              self.invoiceDetails = null;
            }

            alert("Invoice Payment Code " + res.data.code);
          }
        })
        .catch(function (err) {
          self.loadingInvoiceDetails = false;

          console.log(err);
          self.showSnackbar("Failed to mark invoice as paid", "error");
        });
    },
    markAllAsPaid: function (driver, charge = false) {
      console.log("clearing an account");
      let self = this;
      let url = `${this.$store.state.apiUrl}/invoice/driver/markAllAsPaid?take_charge=${charge}`;

      self.loadingInvoiceDetails = true;
      axios({
        url: url,
        method: "POST",
        params: {
          driver_id: driver.driverID,
          notes: driver.notes,
        },
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          self.loadingInvoiceDetails = false;

          if (res.data.error != "no_error") {
            self.showSnackbar("Failed to mark invoices as paid", "error");
          } else {
            self.showSnackbar("All invoices marked as paid", "success");

            self.getInvoicesSummary(self.currentOffset);
            self.getTotals();

            if (
              self.invoiceDetails &&
              self.invoiceDetails.driver.id == driver.driverID
            ) {
              self.invoiceDetails = null;
            }

            alert("Invoice Payment Code " + res.data.code);
          }
        })
        .catch(function (err) {
          self.loadingInvoiceDetails = false;

          console.log(err);
          self.showSnackbar("Failed to mark invoice as paid", "error");
        });
    },
    loadInvoice: function (data) {
      let self = this;
      let invoiceID = data.invoiceID;
      let driver = data.driver;

      //Done like this as may want to fetch other stuff later
      Promise.all([this.getInvoiceDetails(invoiceID)]).then(function (
        success
      ) {
        if (success[0]) {
          self.loadingInvoiceDetails = false;
        }
      });
    },
    updatePaymentType: function (data) {
      console.log("setting driver pay");
      let self = this;
      let bookingID = data.bookingID;
      let url = `${this.$store.state.apiUrl}/invoice/driver/changePaymentType?booking_id=${bookingID}&payment_type=${data.paymentType}`;

      axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          if (res.data.error != "no_error") {
            self.showSnackbar("Failed to change payment type", "error");
          } else {
            self.showSnackbar("Successfully set payment type", "success");
            self.$set(self.invoiceDetails, "invoice", res.data.invoice);

            if (self.invoiceDetails.driver.id == self.currentInvoicesDriverID) {
              self.getInvoicesSummaryForDriver(self.currentInvoicesDriverID);
            }
            self.getTotals();
          }

          self.updateSummaryTotalsForDriver(self.invoiceDetails.driver.id);
          self.getTotals();
        })
        .catch(function (err) {
          console.log(err);
          self.showSnackbar("Failed to set payment type", "error");
        });
    },
    setFinalCost: function (data) {
      let self = this;

      console.log("setting driver pay");
      console.log(data);
      console.log(self.invoiceDetails);
      let bookingID = data.bookingID;
      let amount = Math.round(data.amount * 100);
      let url = `${this.$store.state.apiUrl}/invoice/driver/setBookingFinalCost?booking_id=${bookingID}&amount=${amount}`;

      axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          if (res.data.error != "no_error") {
            self.showSnackbar("Failed to set final cost", "error");
          } else {
            self.showSnackbar("Successfully set final cost", "success");
            self.$set(self.invoiceDetails, "invoice", res.data.invoice);

            if (self.invoiceDetails.driver.id == self.currentInvoicesDriverID) {
              self.getInvoicesSummaryForDriver(self.currentInvoicesDriverID);
            }
            self.getTotals();
          }

          self.updateSummaryTotalsForDriver(self.invoiceDetails.driver.id);
          self.getTotals();
        })
        .catch(function (err) {
          console.log(err);
          self.showSnackbar("Failed to set final cost", "error");
        });
    },
    setDriverPay: function (data) {
      console.log("setting driver pay");
      let self = this;
      let bookingID = data.bookingID;
      let amount = Math.round(data.amount * 100);
      let url = `${this.$store.state.apiUrl}/invoice/driver/manuallySetDriverPay?booking_id=${bookingID}&amount=${amount}`;

      axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          if (res.data.error != "no_error") {
            self.showSnackbar("Failed to set driver pay", "error");
          } else {
            self.showSnackbar("Successfully set driver pay", "success");
            self.$set(self.invoiceDetails, "invoice", res.data.invoice);

            if (self.invoiceDetails.driver.id == self.currentInvoicesDriverID) {
              self.getInvoicesSummaryForDriver(self.currentInvoicesDriverID);
            }
            self.getTotals();
          }

          self.updateSummaryTotalsForDriver(self.invoiceDetails.driver.id);
          self.getTotals();
        })
        .catch(function (err) {
          console.log(err);
          self.showSnackbar("Failed to set driver pay", "error");
        });
    },
    setCommission: function (data) {
      console.log("setting commssion");
      let self = this;
      let bookingID = data.bookingID;
      let amount = Math.round(data.amount * 100);
      let url = `${this.$store.state.apiUrl}/invoice/driver/manuallySetCharge?booking_id=${bookingID}&amount=${amount}`;

      axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          if (res.data.error != "no_error") {
            self.showSnackbar("Failed to set commission", "error");
          } else {
            self.showSnackbar("Successfully set commission", "success");
            self.$set(self.invoiceDetails, "invoice", res.data.invoice);

            if (self.invoiceDetails.driver.id == self.currentInvoicesDriverID) {
              self.getInvoicesSummaryForDriver(self.currentInvoicesDriverID);
            }
            self.getTotals();
          }

          self.updateSummaryTotalsForDriver(self.invoiceDetails.driver.id);
          self.getTotals();
        })
        .catch(function (err) {
          console.log(err);
          self.showSnackbar("Failed to set commission", "error");
        });
    },
    resetCommission: function (bookingID) {
      console.log("resetting commssion");
      let self = this;
      let url = `${this.$store.state.apiUrl}/invoice/driver/resetCharge?booking_id=${bookingID}`;

      axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          if (res.data.error != "no_error") {
            self.showSnackbar("Failed to reset commission", "error");
          } else {
            self.showSnackbar("Successfully reset commission", "success");
            self.$set(self.invoiceDetails, "invoice", res.data.invoice);

            if (self.invoiceDetails.driver.id == self.currentInvoicesDriverID) {
              self.getInvoicesSummaryForDriver(self.currentInvoicesDriverID);
            }
            self.getTotals();
          }

          self.updateSummaryTotalsForDriver(self.invoiceDetails.driver.id);
          self.getTotals();
        })
        .catch(function (err) {
          console.log(err);
          self.showSnackbar("Failed to reset commission", "error");
        });
    },
    addExtra: function (extra) {
      console.log("adding extra");
      let self = this;
      let url = `${this.$store.state.apiUrl}/invoice/driver/addExtra`;
      extra.amount = Math.round(extra.amount * 100);
      axios({
        url: url,
        method: "POST",
        params: extra,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          if (res.data.error != "no_error") {
            self.showSnackbar(
              "Failed to add extra: " + res.data.message,
              "error"
            );
          } else {
            self.showSnackbar("Successfully added extra", "success");
            self.$set(self.invoiceDetails, "invoice", res.data.invoice);

            if (self.invoiceDetails.driver.id == self.currentInvoicesDriverID) {
              self.getInvoicesSummaryForDriver(self.currentInvoicesDriverID);
            }
            self.getTotals();
          }

          self.updateSummaryTotalsForDriver(self.invoiceDetails.driver.id);
          self.getTotals();
        })
        .catch(function (err) {
          console.log(err);
          self.showSnackbar("Failed to add extra", "error");
        });
    },
    removeExtra: function (extraID) {
      console.log("removeing extra");
      let self = this;
      let url = `${this.$store.state.apiUrl}/invoice/driver/removeExtra/?extra_id=${extraID}`;
      axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          if (res.data.error != "no_error") {
            self.showSnackbar(
              "Failed to remove extra: " + res.data.message,
              "error"
            );
          } else {
            self.showSnackbar("Successfully removed extra", "success");
            self.$set(self.invoiceDetails, "invoice", res.data.invoice);

            if (self.invoiceDetails.driver.id == self.currentInvoicesDriverID) {
              self.getInvoicesSummaryForDriver(self.currentInvoicesDriverID);
            }
            self.getTotals();
          }

          self.updateSummaryTotalsForDriver(self.invoiceDetails.driver.id);
          self.getTotals();
        })
        .catch(function (err) {
          console.log(err);
          self.showSnackbar("Failed to remove extra", "error");
        });
    },
    showSnackbar: function (message, colour) {
      this.snackbarMessage = message;
      this.snackbarColour = colour;
      this.snackbarShow = true;
    },
    changeSummaryRows: function (rows) {
      this.$cookies.set("driverSummaryRows", rows, Infinity);
      this.invoicesSummaryRows = parseInt(
        this.$cookies.get("driverSummaryRows")
      );
      this.getInvoicesSummary(0);
    },
    searchDrivers: function () {
      this.getInvoicesSummary(0);
    },
  },
};
</script>
